(function () {
  var URL = 'https://www.pledge.to/widgets/impact/06b6a2417a0d36a7b7513b1d395f299d.json';
  var els = document.querySelectorAll('[data-gg-live-total]');
  if (!els.length || !window.fetch) return;
  fetch(URL, { headers: { Accept: 'application/json' } })
    .then(function (r) { return r.ok ? r.json() : Promise.reject(); })
    .then(function (data) {
      var amount = Number(data && data.amount);
      if (!isFinite(amount) || amount < 1e6) return;
      var text = '$' + Math.floor(amount / 1e6) + 'M+';
      els.forEach(function (el) { el.textContent = text; });
    })
    .catch(function () {});
})();
